import { useApiQuery } from 'mf_core/query';

type CartHeaderDataTO = {
  id: string;
  lineCount: number;
  name: string;
};

export function useCartItemsCount() {
  const query = useApiQuery<CartHeaderDataTO>(
    '/cart/v1/cart-list/default/header-data'
  );
  return (query.data && query.data.lineCount) ?? 0;
}
